
    import Vue from "vue";
    import Component from "vue-class-component";
    import { StateChanger } from "vue-infinite-loading";
    import ApiClient from "@/utilities/ApiClient";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import { SiteSearchParameters } from "@/model/SiteSearchParameters";
    import { ISite, Site } from "@/model/Site";

    @Component({
        components: { PrimaryButton },
    })
    export default class SiteList extends Vue {

        async mounted(): Promise<void> {
            // only with active briefings
            this.searchParameters.withActiveBriefingOnly = true;

            // client ID selected via host name (checked on server)
            // location.host includes port - but in dev mode we may be using multiple ports on locahost - so ignore the port!
            // see also ClientSettings.ts
            this.searchParameters.host = location.hostname;

            const resp: { html: string } = await ApiClient.get(`api/client/siteListHtml?host=${location.hostname}`);
            this.html = resp.html;
        }

        infiniteId: number = + new Date();
        searchParameters = new SiteSearchParameters();
        html: string = "";
        siteList: Array<ISite> = [];

        onSiteSelected(site: ISite) {
            //this.$router.push({ name: "Scan", params: { direction: "arriving" } });
            this.$router.push({ name: "VisitorSiteRegister", params: { siteID: site.id } });
        }

        refreshSearch(): void {
            this.siteList = [];
            this.searchParameters.pageNumber = 1;
            this.infiniteId += 1;
        }

        siteImageSource(site: Site): string {
            return site?.imageResource?.sourceUrl ?? require("@/images/missing.png");
        }

        async infiniteLoadingHandler(stateChanger: StateChanger): Promise<void> {
            const response = await ApiClient.post("/Api/Site/Search", this.searchParameters);
            if (response.list?.length) {
                this.siteList.push(...response.list.map((s: ISite) => new Site(s)));
                this.searchParameters.pageNumber += 1;
                stateChanger.loaded();
            }
            else {
                stateChanger.complete();
            }
        }
    }
